import api from "./api.reducers";
import auth from "./auth.reducers";
import config from "./config.reducers";
import promotion from "./promotion.reducers";
import users from "./users.reducers";
import shipmentServices from "./shipmentServices.reducers";
import bundlePromotion from './bundlePromotion.reducers';
import bulkBundlePromotion from './bulkBundleUtility.reducers'
import paymentMethods from "./paymentMethods.reducers";
export default { api, auth, config, promotion, users, shipmentServices, bundlePromotion, bulkBundlePromotion, paymentMethods };
